// sheet-format-tiles.js — [is-sheet-format-select] → tuiles comme les délais (delay-tiles), scope .imposition-v3

(function () {
  function calcT(key, fallback, vars) {
    var dict = window.__calculatorI18n || {};
    var text = dict[key] != null ? String(dict[key]) : String(fallback == null ? key : fallback);
    if (vars) Object.keys(vars).forEach(function (name) { text = text.split('{' + name + '}').join(String(vars[name])); });
    return text;
  }

  function impositionSection() {
    return document.querySelector("section.imposition-v3");
  }

  function hideSelectVisually(select) {
    var wrap = select.closest(".select--wrap") || select.parentElement;
    if (!wrap) return;
    wrap.style.position = "absolute";
    wrap.style.width = "1px";
    wrap.style.height = "1px";
    wrap.style.padding = "0";
    wrap.style.margin = "-1px";
    wrap.style.overflow = "hidden";
    wrap.style.clipPath = "inset(50%)";
    wrap.style.border = "0";
    wrap.style.whiteSpace = "nowrap";
    wrap.style.pointerEvents = "none";
    select.style.opacity = "0";
    select.style.width = "1px";
    select.style.height = "1px";
  }

  function removeTilesAfterWrap(select) {
    var wrap = select.closest(".select--wrap");
    if (!wrap) return;
    var el = wrap.nextElementSibling;
    while (el && el.classList && el.classList.contains("sheet-format-tiles")) {
      var next = el.nextElementSibling;
      el.remove();
      el = next;
    }
  }

  function titleSubtitle(opt) {
    var v = (opt.value || "").trim();
    var full = (opt.textContent || "").trim();
    var sub = "";
    var parts = full.split(/\s*—\s*/);
    if (parts.length > 1) {
      sub = parts.slice(1).join(" — ").trim();
    }
    var main = v || (parts[0] ? parts[0].trim() : full);
    return { main: main, sub: sub };
  }

  function makeSheetFormatTiles(select) {
    var section = impositionSection();
    if (!section || !section.contains(select)) return;

    removeTilesAfterWrap(select);

    var opts = Array.prototype.slice.call(select.options || []).filter(function (o) {
      return (o.value || "").trim() !== "";
    });
    if (!opts.length) return;

    var wrapAnchor = select.closest(".select--wrap");
    if (!wrapAnchor) return;

    var host = select.closest(".input--box");
    if (host) host.style.position = "relative";

    var row = document.createElement("div");
    row.className = "sheet-format-tiles";
    row.setAttribute("role", "radiogroup");
    row.setAttribute("aria-label", calcT("sheet_format_aria", "Format de planche"));

    var tiles = [];

    opts.forEach(function (opt) {
      var ts = titleSubtitle(opt);
      var tile = document.createElement("button");
      tile.type = "button";
      tile.className = "delay-tile sheet-format-tile";
      tile.setAttribute("role", "radio");
      tile.setAttribute("aria-checked", opt.selected ? "true" : "false");
      tile.dataset.value = opt.value;

      var jEl = document.createElement("div");
      jEl.className = "delay-tile__j";
      jEl.textContent = ts.main;

      var tierEl = document.createElement("div");
      tierEl.className = "delay-tile__tier";
      tierEl.textContent = ts.sub || "\u00a0";

      tile.appendChild(jEl);
      tile.appendChild(tierEl);

      tile.addEventListener("click", function () {
        select.value = opt.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        tiles.forEach(function (t) {
          t.setAttribute("aria-checked", "false");
        });
        tile.setAttribute("aria-checked", "true");
      });

      row.appendChild(tile);
      tiles.push(tile);
    });

    wrapAnchor.insertAdjacentElement("afterend", row);

    function syncAria() {
      var val = select.value;
      tiles.forEach(function (t) {
        t.setAttribute("aria-checked", t.dataset.value === val ? "true" : "false");
      });
    }

    if (select._sheetFormatTilesAbort) select._sheetFormatTilesAbort.abort();
    var ac = new AbortController();
    select._sheetFormatTilesAbort = ac;
    select.addEventListener("change", syncAria, { signal: ac.signal });

    hideSelectVisually(select);
    syncAria();
  }

  var debouncers = new WeakMap();

  function debouncedRebuild(select) {
    var id = debouncers.get(select);
    if (id) clearTimeout(id);
    id = setTimeout(function () {
      debouncers.delete(select);
      makeSheetFormatTiles(select);
    }, 60);
    debouncers.set(select, id);
  }

  function bindSelect(select) {
    if (!select || select.dataset.sheetFormatTilesBound === "1") return;
    select.dataset.sheetFormatTilesBound = "1";
    makeSheetFormatTiles(select);
    var obs = new MutationObserver(function () {
      debouncedRebuild(select);
    });
    obs.observe(select, { childList: true, subtree: true });
  }

  function scanForSelects(container) {
    if (!container) return;
    Array.prototype.forEach.call(container.querySelectorAll("[is-sheet-format-select]"), function (sel) {
      bindSelect(sel);
    });
  }

  function init() {
    var root = impositionSection();
    if (!root) return;
    scanForSelects(root);
    var list = root.querySelector("[is-sheet-params-list]");
    if (list && !list._sheetFormatTilesListObs) {
      list._sheetFormatTilesListObs = true;
      var mo = new MutationObserver(function () {
        scanForSelects(list);
      });
      mo.observe(list, { childList: true, subtree: true });
    }
  }

  function scheduleInit() {
    init();
    requestAnimationFrame(function () {
      requestAnimationFrame(init);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleInit, { once: true });
  } else {
    scheduleInit();
  }
})();